import reduceReducers from 'reduce-reducers';

import loginReducer from './login-reducer';

export default reduceReducers(loginReducer);
